module.exports = __webpack_public_path__ + "img/index_kj.426433d1.svg";